import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Component, Vue } from 'vue-property-decorator';

/**
 * @figma https://www.figma.com/file/cBHD57QcCt9WDT4e7e2B3w/hse_general_library?node-id=2681%3A5
 * @storybook /?path=/story/content-content--playground
 * @react /src-components-paragraph
 * @reactStorybook /?path=/story/content-content--playground
 */
var HseParagraph = /** @class */ (function (_super) {
    __extends(HseParagraph, _super);
    function HseParagraph() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Prop({
            default: false
        }),
        __metadata("design:type", Boolean)
    ], HseParagraph.prototype, "small", void 0);
    __decorate([
        Prop({
            default: false
        }),
        __metadata("design:type", Boolean)
    ], HseParagraph.prototype, "hasMargin", void 0);
    HseParagraph = __decorate([
        Component({
            name: 'HseParagraph'
        })
    ], HseParagraph);
    return HseParagraph;
}(Vue));

export default HseParagraph;
